<template>
    <div class="ma-1">
        <p class="text-subtitle-1 my-3 font-weight-medium font-weight-black">
            Orders and subscriptions
            <v-btn v-if="bo" x-small class="mt-1 ml-2 white--text" color="green darken-4"
                :to="{name:'journal.edit.bo',params:{id:this.$route.params.journal_id,model:'Subscriptions'}}" >
                edit
            </v-btn>
        </p>
        <a v-if="journal.distributor.logo"
            :title="journal.distributor.title"
            :href="journal.distributor.url"
            class="blue--text text--darken-4">
            <v-img
                :src="require('../../../assets/library/springer-logo.png')"
                max-height="64"
                max-width="203"
                contain
                class="ma-0"
            ></v-img>
        </a>
        <div v-html="subscriptions.text" class="ql-ed">
        </div>

        <p v-if="journal.id==3" class="ml-3 mb-0 d-flex justify-center"><span class="font-weight-bold">ISSN:</span>{{ journal.ISSNP }}</p>
        <p v-if="journal.id==3" class="ml-3 mb-0 d-flex justify-center"><span class="font-weight-bold">eISSN:</span>{{ journal.ISSNE }}</p>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import router from '../../../router';

export default {
     props:{
        bo: {
            type:Boolean,
            default:false
        },
    },
    data() {
        return{
            subscriptions:{
                text:''
            },
        }
    },
    created() {
        this.getSubscriptions();
    },
    computed:{
        ...mapGetters('library',{
            journal:'journal',
        })
    },
    methods: {
        async getSubscriptions(){
            try{
                const res = await axios.get('/index.php/api/library/journals/subscription/'+this.$route.params.journal_id );
                if(res){
                    this.subscriptions.text = res.data;
                }
            } catch (error) {
                throw error;
            }
        },
    }

}
</script>
